import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    ITimesheetFormControls,
    IWeeklyTotalsFormControls,
} from 'src/app/interfaces/timesheets';
import { ThemeService } from 'src/app/services/theme.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { daysOfWeek } from 'src/app/constants/timesheetConstants';
import { TitleCasePipe } from '@angular/common';
import { Day } from 'src/app/types/dayType';

@Component({
    selector: 'app-timesheet-totals',
    templateUrl: './timesheet-totals.component.html',
    styleUrls: ['./timesheet-totals.component.scss'],
    imports: [MatDividerModule, MatCardModule, TitleCasePipe],
})
export class TimesheetTotalsComponent implements OnInit {
    @Input() weeklyTotalsFormGroup: FormGroup<IWeeklyTotalsFormControls>;
    @Input() timesheetForms: FormGroup<ITimesheetFormControls>[];
    protected daysOfWeek = daysOfWeek;
    constructor(private themeService: ThemeService) {}

    ngOnInit(): void {
        this.calcTotals(this.timesheetForms);
    }

    calcTotals(timesheetForms: FormGroup<ITimesheetFormControls>[]): void {
        const totals = daysOfWeek.reduce(
            (totalObj, day) => {
                totalObj[`${day.name}Total`] = 0;
                return totalObj;
            },
            {} as Record<`${Day}Total`, number>,
        );

        timesheetForms.forEach((form) => {
            daysOfWeek.forEach((day) => {
                totals[`${day.name}Total`] += form.controls[day.name].value;
            });
        });

        daysOfWeek.forEach((day) => {
            this.weeklyTotalsFormGroup.controls[`${day.name}Total`].setValue(
                totals[`${day.name}Total`],
            );
        });
        const weekTotal = daysOfWeek.reduce(
            (sum, day) => sum + totals[`${day.name}Total`],
            0,
        );
        this.weeklyTotalsFormGroup.controls.weekTotal.setValue(weekTotal);
    }

    protected get darkMode(): boolean {
        const mode = this.themeService.getCurrentTheme();
        if (mode.toLowerCase() == 'dark-theme') {
            return true;
        } else {
            return false;
        }
    }
}
